import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import _ from 'lodash'
import { injectIntl, defineMessages } from 'react-intl'
import { correctClasses } from '../../common/config'
import { Button } from '../components'

import './Pexeso.scss'

class Pexeso extends React.Component {
  constructor(props) {
    super(props)

    const { lesson } = this.props
    const { words } = lesson
    
    const slicedWords = words.slice(0, 12)

    /* move to redux */
    const flatWords = [
      ...slicedWords.map((word, id) => ({ id, word: word.baseWord, type: 'base' })),
      ...slicedWords.map((word, id) => ({ id, word: word.foreignWord, type: 'foreign' })),
    ]

    const tiles = _.shuffle(flatWords)

    this.state = {
      selected: null,
      guessed: [],
      tiles,
    }
  }

  setSelected(current) {
    const { guessed, selected } = this.state
    if ((selected && selected.find(item => item.id === current.id && item.word === current.word))
     || guessed.includes(current.id)) return

    if (selected !== null) {
      if (current.id === selected[0].id) {
        this.setState({ guessed: [...guessed, current.id], selected: null })
      } else {
        this.setState({ selected: [...selected, current] })
        setTimeout(() => {
          this.setState({ selected: null })
        }, 500)
      }
    } else {
      this.setState({ selected: [current] })
    }
  }

  refreshGame() {
    this.setState({
      selected: null,
      guessed: [],
      tiles: _.shuffle(this.state.tiles),
    })
  }

  render() {
    const { intl } = this.props
    const { tiles, guessed, selected } = this.state

    const tilesWidth = 100 / Math.ceil(Math.sqrt(tiles.length))

    return (
      <React.Fragment>
        <div className="pexeso">
          {
            tiles.map((tile, id) => (
              <div
                key={`${tile.word}-${id}`}
                onClick={() => this.setSelected(tile)}
                className={`tile ${guessed.includes(tile.id) ? 'guessed-tile' : ''} ${(selected && selected.find(item => item.id === tile.id && item.word === tile.word)) ? 'selected-tile' : ''}`}
                // style={{ width: `${tilesWidth - 5}%` }}
              >
                {
                  ((selected && selected.find(item => item.id === tile.id && item.word === tile.word)) ||
                  guessed.includes(tile.id)) &&
                  <p>{tile.word}</p>
                }
              </div>
            ))
          }
        </div>
        <Button
          positive
          className="spacing-top"
          onClick={() => this.refreshGame()}
        >
          {intl.formatMessage(messages.tryAgain)}
        </Button>
      </React.Fragment>
    )
  }
}

Pexeso.defaultProps = {
  lesson: null,
}

Pexeso.propTypes = {
  intl: PropTypes.object.isRequired,
  lesson: PropTypes.object,
}

const enhance = compose(
  injectIntl,
  connect(state => ({
    exam: state.tests.exam,
  }), { }),
)

export default enhance(Pexeso)

const messages = defineMessages({
  tryAgain: {
    id: 'pexeso.tryAgain',
    defaultMessage: 'Hrať znovu',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/Pexeso.js